import {
  FormFieldWidget,
  FormO2MTableFieldWidget,
  ModelFieldType,
  SPI,
  SubmitRelationValue,
  SubmitValue,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { RuntimeO2MField } from '@kunlun/dependencies';
import IndicatorTable from './IndicatorTable.vue';

/**
 * 编辑评估规则 - 评估指标配置自定义 Widget
 *
 * <p>渲染「指标 1:N 区间」的嵌套 rowspan 表格：
 * 每个指标可选固定指标名称（按适用渠道过滤，见 constants.ts），下挂多个分值区间（运算符 + 阈值 + 得分）。</p>
 *
 * <p>绑定字段：DeliAriesPlatformEvaluationRule.indicators（OneToMany）。
 * 复用默认 O2M widget 名 'Table' + 字段名 'indicators' 精确覆盖，无需改设计器。
 * 同时注册 Detail 视图：详情页复用编辑布局但全表只读。
 * 注意：indicators 由父模型继承而来，运行时字段归属可能是父模型，故不约束 model，仅按 name 匹配（与 OrderPlanProductDetail 一致）。</p>
 */
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Detail],
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'indicators',
    multi: true
  })
)
export class FormIndicatorTableFieldWidget extends FormO2MTableFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(IndicatorTable);
    return this;
  }

  @Widget.Reactive()
  public get _field(): RuntimeO2MField {
    return this.field as RuntimeO2MField;
  }

  /** 详情视图下只读（作为 prop 传给组件，与 _field 同机制） */
  @Widget.Reactive()
  public get isReadonly(): boolean {
    return this.getUrlParameters().viewType === ViewType.Detail;
  }

  /**
   * 直接以 { 字段名: 完整嵌套数组 } 提交，绕开基类的 O2M 序列化。
   *
   * <p>基类 submit() 会按子视图声明的字段元数据过滤，而设计器里 indicators 的内层表格
   * 未声明 indicatorName，也未声明第三层 ranges 的 operator/minValue/maxValue/score，
   * 导致子记录被创建但标量字段全为 NULL。此处直接返回组件维护的完整数据。</p>
   */
  public async submit(submitValue: SubmitValue): Promise<SubmitRelationValue | Record<string, unknown> | undefined> {
    return { [this.itemName]: this.value || [] };
  }
}
